export default __webpack_public_path__ + "static/media/039-gas-mask.47646498.png";